import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth.store';

/**
 * AP-29-E — Zugang zur Betreiber-Konsole im Frontend.
 *
 * Bewusst **kein** `requiredRole`: Die Rollenhierarchie gilt innerhalb eines
 * Mandanten, und `SUPER_ADMIN` hat auch der Administrator eines Kunden. Hier
 * entscheidet allein die Zugehörigkeit zum Betreiber-Mandanten.
 *
 * **Das ist keine Sicherheitsgrenze** — die liegt im `PlatformAdminGuard` des
 * Backends, der jede Antwort verweigert. Diese Route sorgt nur dafür, dass
 * niemand vor einer Seite steht, die ausschließlich 403 liefert.
 *
 * Umgeleitet wird wortlos aufs Dashboard: Wer hier nicht hingehört, muss nicht
 * erfahren, dass es die Konsole überhaupt gibt.
 */
export function OperatorRoute() {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <span className="text-sm text-muted-foreground">Laden…</span>
      </div>
    );
  }

  if (user?.isOperator !== true) return <Navigate to="/" replace />;

  return <Outlet />;
}
